import type { OptionType } from '@hivebrite/design-system/Inputs';

export const categoriesToOptions = (
  categories: { id: number; name: string }[],
) =>
  categories.map<OptionType>((category) => ({
    value: category.id,
    label: category.name,
  }));
